var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"User Device"}},[_c('div',{attrs:{"clss":"vx-row"}},[_c('data-table',{attrs:{"baseUrl":this.baseUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }